export default __webpack_public_path__ + "src/images/text_loading-3b5534.png";